import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'prefixWithDots'})
export class PrefixWithDotsPipe implements PipeTransform {
  transform(string:string, maxlength:number):string {
    if(!string) return "";
    if(string.length <= maxlength) return string;
    return string.slice(0, maxlength - 3) + "...";
  }
}